import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'versafleet-core';

class MobileGlobalSearchSeparator extends React.Component {
  _renderLeftString() {
    return (
      <div className="vf-mobile-global-search__dropdown__separator__string">
        {this.props.jobOrTask}
      </div>
    );
  }

  _renderHorizontalLine = () => (
    <div className="vf-mobile-global-search__dropdown__separator__line" />
  );

  _renderItemNumber() {
    return (
      <div className="vf-mobile-global-search__dropdown__separator__string">
        (
        {this.props.itemNumber}
        )
      </div>
    );
  }

  render() {
    return (
      <div className="vf-mobile-global-search__dropdown__separator">
        {this._renderLeftString()}
        {this._renderHorizontalLine()}
        {this._renderItemNumber()}
      </div>
    );
  }
}

MobileGlobalSearchSeparator.displayName = 'Mobile Global Search Item';

MobileGlobalSearchSeparator.propTypes = {
  itemNumber: PropTypes.number.isRequired,
  jobOrTask: PropTypes.string.isRequired,
};

export default translate('GlobalSearch')(MobileGlobalSearchSeparator);
